import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[700px] md:min-h-[820px] flex items-center overflow-hidden bg-white">
      {/* 大背景渐变光晕 - 呼吸效果 */}
      <div
        className="absolute inset-0 pointer-events-none animate-breathe-slow"
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 60% 40%, rgba(0,174,239,0.08) 0%, transparent 70%), radial-gradient(ellipse 50% 50% at 20% 80%, rgba(30,95,173,0.06) 0%, transparent 60%)',
        }}
      />

      {/* 额外光晕 - 缓慢漂移 */}
      <div
        className="absolute top-[-100px] right-[20%] w-[600px] h-[600px] rounded-full pointer-events-none animate-float-slow"
        style={{
          background: 'radial-gradient(circle, rgba(0,174,239,0.06) 0%, transparent 60%)',
        }}
      />
      <div
        className="absolute bottom-[-80px] left-[10%] w-[500px] h-[500px] rounded-full pointer-events-none animate-float-reverse"
        style={{
          background: 'radial-gradient(circle, rgba(30,95,173,0.04) 0%, transparent 60%)',
        }}
      />

      {/* 极淡网格纹理 */}
      <div
        className="absolute inset-0 opacity-[0.02] pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(#1E5FAD 1px, transparent 1px), linear-gradient(90deg, #1E5FAD 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      {/* 浮动圆形装饰区域 - 缓慢浮动 */}
      <div className="absolute right-0 top-0 w-[600px] h-[600px] pointer-events-none overflow-hidden animate-float">
        <div
          className="absolute top-[-80px] right-[-80px] w-[480px] h-[480px] rounded-full animate-breathe"
          style={{ background: 'radial-gradient(circle, #00AEEF 0%, transparent 70%)' }}
        />
        <div
          className="absolute top-[60px] right-[60px] w-[320px] h-[320px] rounded-full animate-breathe-slow"
          style={{ background: 'radial-gradient(circle, #1E5FAD 0%, transparent 70%)', animationDelay: '2s' }}
        />
      </div>

      {/* 左侧装饰小光点 - 轨道运动 */}
      <div className="absolute top-[30%] left-[8%] pointer-events-none animate-orbit" style={{ animationDuration: '18s' }}>
        <div className="w-3 h-3 bg-[#00AEEF]/20 rounded-full blur-[1px]" />
      </div>
      <div className="absolute top-[60%] left-[12%] pointer-events-none animate-orbit-reverse" style={{ animationDuration: '22s' }}>
        <div className="w-2 h-2 bg-[#1E5FAD]/15 rounded-full blur-[1px]" />
      </div>
      <div className="absolute top-[45%] left-[5%] pointer-events-none animate-orbit" style={{ animationDuration: '16s', animationDelay: '5s' }}>
        <div className="w-1.5 h-1.5 bg-[#00AEEF]/15 rounded-full" />
      </div>

      {/* 右侧装饰浮动元素 */}
      <div className="absolute top-[20%] right-[35%] pointer-events-none animate-float-slow" style={{ animationDelay: '1s' }}>
        <div className="w-2 h-2 bg-[#00AEEF]/20 rounded-full" />
      </div>
      <div className="absolute bottom-[25%] right-[30%] pointer-events-none animate-float" style={{ animationDelay: '3s' }}>
        <div className="w-1.5 h-1.5 bg-[#1E5FAD]/15 rounded-full" />
      </div>
      <div className="absolute top-[35%] right-[25%] pointer-events-none animate-float-reverse" style={{ animationDelay: '2s' }}>
        <div className="w-1 h-1 bg-[#00AEEF]/25 rounded-full" />
      </div>

      {/* 装饰横线 - 波动效果 */}
      <div className="absolute top-[25%] left-0 w-[200px] h-px bg-gradient-to-r from-[#00AEEF]/10 to-transparent pointer-events-none animate-wave-line" />
      <div className="absolute top-[55%] left-[5%] w-[150px] h-px bg-gradient-to-r from-[#1E5FAD]/10 to-transparent pointer-events-none animate-wave-line" style={{ animationDelay: '2s' }} />
      <div className="absolute bottom-[30%] left-[10%] w-[120px] h-px bg-gradient-to-r from-[#00AEEF]/10 to-transparent pointer-events-none animate-wave-line" style={{ animationDelay: '4s' }} />

      {/* 右侧装饰环 - 带旋转动画 */}
      <div className="hidden xl:block absolute right-[8%] top-1/2 -translate-y-1/2 pointer-events-none">
        <div className="relative w-[380px] h-[380px] animate-float-rotate">
          {/* 外环 - 慢速旋转 */}
          <div className="absolute inset-0 rounded-full border border-[#00AEEF]/12 animate-spin-slow" />
          {/* 中环 - 反向旋转 */}
          <div className="absolute inset-[40px] rounded-full border border-[#1E5FAD]/10 animate-spin-slow-reverse" />
          {/* 内环 - 慢速旋转 */}
          <div className="absolute inset-[80px] rounded-full border border-[#00AEEF]/8 animate-spin-slow" style={{ animationDuration: '30s' }} />
          {/* 中心背景 */}
          <div className="absolute inset-[120px] rounded-full bg-gradient-to-br from-[#1E5FAD]/6 to-[#00AEEF]/6 animate-breathe-slow" />
          {/* 轨道上的小光点 */}
          <div className="absolute inset-0 animate-spin-slow" style={{ animationDuration: '12s' }}>
            <div className="absolute top-[20px] left-1/2 w-2 h-2 bg-[#00AEEF]/40 rounded-full" />
          </div>
          <div className="absolute inset-0 animate-spin-slow-reverse" style={{ animationDuration: '18s' }}>
            <div className="absolute bottom-[40px] right-[40px] w-1.5 h-1.5 bg-[#1E5FAD]/30 rounded-full" />
          </div>
          <div className="absolute inset-0 animate-spin-slow" style={{ animationDuration: '24s', animationDelay: '6s' }}>
            <div className="absolute top-1/2 left-[20px] w-1.5 h-1.5 bg-[#00AEEF]/25 rounded-full" />
          </div>
          {/* 中心图标 */}
          <div className="absolute inset-[140px] flex items-center justify-center animate-breathe">
            <div className="w-full h-full rounded-full bg-gradient-to-br from-[#1E5FAD] to-[#00AEEF] flex items-center justify-center">
              <i className="ri-bar-chart-grouped-line text-white text-3xl" />
            </div>
          </div>
        </div>
      </div>

      {/* 内容区域 */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 pt-28 pb-20 md:pt-36 md:pb-28">
        <div className="max-w-2xl xl:max-w-3xl">
          {/* 主标题 */}
          <h1
            className={`text-3xl sm:text-4xl md:text-5xl font-bold text-[#1E5FAD] leading-[1.2] mb-4 transition-all duration-700 delay-100 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
          >
            营销数字化最佳实践者
          </h1>

          {/* 核心价值主张 - 一行设计 */}
          <div
            className={`inline-flex items-center gap-3 bg-[#1E5FAD]/[0.04] border border-[#1E5FAD]/10 rounded-xl pl-4 pr-5 py-3 mb-8 transition-all duration-700 delay-200 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <div className="w-1 h-6 rounded-full bg-[#00AEEF] flex-shrink-0" />
            <p className="text-sm md:text-base lg:text-lg font-semibold text-[#333333] leading-snug whitespace-nowrap">
              多元促销精管终端，实时监控渠道库存，实现营销费用可视、可控、精准投放
            </p>
          </div>

          {/* 描述文字 */}
          <p
            className={`text-sm md:text-base text-[#666666]/80 leading-relaxed mb-10 transition-all duration-700 delay-300 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            专注营销数字化战略咨询 × 运营陪跑服务× bC一体化SaaS系统 ，助力品牌构建端到端营销数字化闭环
          </p>

          {/* CTA 按钮 */}
          <div
            className={`flex flex-col sm:flex-row gap-3 transition-all duration-700 delay-500 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-[#00AEEF] text-white font-semibold rounded-md hover:bg-[#0099d4] transition-all duration-200 whitespace-nowrap text-sm md:text-base"
            >
              <i className="ri-calendar-check-line" />
              预约专属客服
            </Link>
            <Link
              to="/cases"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-[#1E5FAD]/30 text-[#1E5FAD] font-semibold rounded-md hover:bg-[#1E5FAD]/5 transition-all duration-200 whitespace-nowrap text-sm md:text-base"
            >
              <i className="ri-file-list-3-line" />
              查看成功案例
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}